import React from "react";

const Bar = ({ remaining }) => {
  return (
    <div
      className="shadow-inner"
      style={{
        margin: "10px",
        borderRadius: "12px",
        padding: "10px",
        overflow: "hidden",
      }}
    >
      <span
        style={{
          width: "100%",
          height: "25px",
          borderRadius: "12px",
          backgroundColor: "#eee",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <span
          style={{
            display: "flex",
            width: `${remaining}%`,
            height: "100%",
            borderRadius: "12px",
            backgroundColor: "rgb(0 129 86)",
            color: "white",
            justifyContent: "center",
            alignItems: "center",
            padding: "5px",
            boxSizing: "border-box",
            fontSize: "14px",
          }}
        >
          {remaining > 7 && `%${remaining}`}
        </span>
      </span>
    </div>
  );
};

export default Bar;
